import { apiClient } from "../../Service";
const getNavigationInfo = async () => {
    const client = apiClient();
    return await client
        .post("/default/ajax?ajax=get_navigation_info")
        .then((response) => {
        return {
            isLoggedIn: !!response.is_logged_in,
            isHidePremium: !!response.is_hide_premium,
        };
    });
};
export { getNavigationInfo };
